import { mapMultiSelectDropDownField } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../../contexts/app';
import { useNetworkGroups } from '../../../../../app-init-data/useNetworkGroups';
import { QuotePlanSchema } from '../../../server/map-quotes';
import { QuoteFilters } from '../useQuoteFilterSchema';

export const usePlanNetworkGroups = (originalQuotes: QuotePlanSchema[]) => {
	const { translate } = useAppPlatformContextOptions();
	const { networkGroups } = useNetworkGroups();

	const availableNetworkGroups = [...new Set(originalQuotes?.map((q) => q.networkGroupId))];
	const qualifiedNetworkGroups = availableNetworkGroups?.map((ng) => {
		const networkData = networkGroups?.find((i) => i.id === ng);

		return { ...networkData };
	});

	const getNetworkGroups = mapMultiSelectDropDownField<QuoteFilters, { id?: number; name?: string }, 'id'>({
		field: 'networkId',
		isEditable: true,
		options: qualifiedNetworkGroups,
		label: translate('quote-list:filters.network'),
		placeholder: translate('quote-list:select'),
		isHidden: false,
		valueKey: 'id',
		labelKey: 'name',
		cancelButtonText: translate('quote-list:filters.cancel'),
		applyButtonText: translate('quote-list:filters.apply'),
	});

	return { getNetworkGroups };
};
